// #region Dependencias
import AppRouter from 'routers/AppRouter'
import { Loader, Main } from 'components/Library'
import 'services/i18n'
import { Suspense } from 'react'
// #endregion

/**
 * Componente principal de la aplicación que configura y renderiza la interfaz de usuario.
 * @class
 */
const App = () => {
  return (
    <Main>
      <Suspense fallback={<Loader />}>
        <Loader />
        <AppRouter />
      </Suspense>
    </Main>
  )
}

export default App
